import Utils from './_utils';
import { Config } from './_config';
import Main from './common/_main';

window.UTILS = Utils;
window.CONFIG = UTILS.getDeepFreezeObj(Config);

const main = new Main();
